'use strict';

export function dyanne_platformFavorite(element) {
    const savedState = element.getAttribute('data-favorite-saved');
    const productID = element.getAttribute('data-product-id');

    if (savedState === 'true') {
        element.setAttribute('data-favorite-saved', 'false');
        element.classList.remove('saved');

        const favoriteData = new FormData();
        favoriteData.append( 'item_id', productID );
        favoriteData.append( 'action', 'dyanne_platform_remove_favorite_item' );

        fetch(dyanne_platform_xhr.ajaxurl, {
            method: 'POST',
            body: favoriteData,
        })
        .then(response => response.json())
        .then(data => {
            console.log('Success:', data);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    } else {
        element.setAttribute('data-favorite-saved', 'true');
        element.classList.add('saved');

        const favoriteData = new FormData();
        favoriteData.append('item_id', productID);
        favoriteData.append('action', 'dyanne_platform_store_favorite_item');
        favoriteData.append('wpnonce', dyanne_platform_xhr.nonce);

        fetch(dyanne_platform_xhr.ajaxurl, {
            method: 'POST',
            cache: 'no-cache',
            body: favoriteData,
        })
        .then(response => response.json())
        .then(data => {
            console.log('Success:', data);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
}